<template>
    <div class="activateView">
        
    </div>
</template>
